import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CookieBanner from '../components/CookieBanner';

const Impressum = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header onSubscribeClick={() => {}} />
      
      <main className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <h1 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-4">
          Impressum
        </h1>
        <p className="text-sm text-neutral-500 mb-12">
          Legal Information
        </p>

        <div className="prose prose-lg max-w-none space-y-8 text-neutral-700">
          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">Publisher Information</h2>
            <div className="bg-neutral-50 p-6 rounded-lg">
              <p className="font-semibold mb-2">News Pty Limited</p>
              <p>
                ACN: 007 871 187<br />
                ABN: 47 007 871 187<br />
                Registered in Australia
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">Registered Address</h2>
            <div className="bg-neutral-50 p-6 rounded-lg">
              <p>
                2 Holt Street<br />
                Surry Hills NSW 2010<br />
                Australia
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">Contact Information</h2>
            <div className="bg-neutral-50 p-6 rounded-lg space-y-2">
              <p>
                <span className="font-semibold">Phone:</span> +61 2 9288 3000
              </p>
              <p>
                <span className="font-semibold">Email:</span> info@Artinent.com
              </p>
              <p>
                <span className="font-semibold">Website:</span> www.Artinent.com
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">Management</h2>
            <div className="bg-neutral-50 p-6 rounded-lg">
              <p>
                Managing Director: Sarah Mitchell<br />
                Editor-in-Chief: James Anderson<br />
                Chief Technology Officer: Michael Chen
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">Responsible for Content</h2>
            <div className="bg-neutral-50 p-6 rounded-lg">
              <p>
                Editor-in-Chief<br />
                News Pty Limited<br />
                2 Holt Street<br />
                Surry Hills NSW 2010<br />
                Australia
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">Regulatory Authority</h2>
            <div className="bg-neutral-50 p-6 rounded-lg">
              <p>
                Australian Securities and Investments Commission (ASIC)<br />
                Level 7, 120 Collins Street<br />
                Melbourne VIC 3000<br />
                Australia
              </p>
              <p className="mt-4">
                <span className="font-semibold">ACN:</span> 007 871 187<br />
                <span className="font-semibold">ABN:</span> 47 007 871 187
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">Professional Liability Insurance</h2>
            <div className="bg-neutral-50 p-6 rounded-lg">
              <p>
                Insurer: Australian Insurance Group<br />
                Policy Number: AIG-789456-2024<br />
                Coverage: Professional Indemnity Insurance<br />
                Coverage Amount: $5,000,000 AUD
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">Copyright</h2>
            <p>
              All content on this website, including text, graphics, logos, images, and software, is the property of Artinent.com Media Pty Ltd or its content suppliers and is protected by Australian and international copyright laws.
            </p>
            <p className="mt-4">
              © {new Date().getFullYear()} News Pty Limited. All rights reserved.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">Disclaimer</h2>
            <p>
              The information on this website is provided for general information purposes only. While we endeavor to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose.
            </p>
          </section>
        </div>
      </main>

      <Footer />
      <CookieBanner />
    </div>
  );
};

export default Impressum;
